<template>
  <div class="about">
    <h1>This is an about page</h1>
    <van-button type="primary"> 主要按钮 </van-button>
    <p>{{ $t("verify_btn") }}</p>
  </div>
</template>
<script>
  import { Button } from "vant";
  
  export default {
    name: "HelloWorld",
    a: "aaaaaaaa",
    components: {
      vanButton: Button,
    },
    props: {
      msg: {
        type: String,
        default: "aaa",
      }
    },
    data() {
      return {
        aa: "aaa",
      };
    }
  }
</script>
